export const optionalTranslation = (translation) => {
	return translation || undefined;
};
